import React from 'react';
import MasonDashboard from '../components/MasonDashboard';

/**
 * MasonDashboardPage – full page for Mason role.
 * Wraps the MasonDashboard component.
 */
export default function MasonDashboardPage() {
  return <MasonDashboard />;
}
